module.exports = __webpack_public_path__ + "static/nails-6a923ba0c8e1f093f6ed4bd87808632c.jpg";